import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["fill"];
import React from 'react';
var SVG_PATHS = [{
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  d: 'M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM12.9842 14.6342C11.8588 15.4314 10.4841 15.9 9 15.9C5.18924 15.9 2.1 12.8108 2.1 9C2.1 7.51587 2.56857 6.14118 3.36584 5.01579L12.9842 14.6342ZM14.4944 13.1745L4.82549 3.50559C5.98455 2.6236 7.43113 2.1 9 2.1C12.8108 2.1 15.9 5.18924 15.9 9C15.9 10.5689 15.3764 12.0155 14.4944 13.1745Z'
}];
export var DEFAULT_FILL_NO_EVIDENCE = '#6A7883';
export var NoEvidenceIcon = function NoEvidenceIcon(_ref) {
  var _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? DEFAULT_FILL_NO_EVIDENCE : _ref$fill,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    id: "no_evidence",
    width: "18",
    height: "18",
    viewBox: "-1 -1 20 20",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "No Evidence"
  }, props), SVG_PATHS.map(function (pathProps, index) {
    return /*#__PURE__*/React.createElement("path", Object.assign({
      key: index
    }, pathProps));
  }));
};
export var noEvidenceIconSvgPaths = SVG_PATHS.map(function (p) {
  return "<path fill-rule=\"".concat(p.fillRule, "\" d=\"").concat(p.d, "\"/>");
}).join('');